import { Component, Inject, OnInit, Optional } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Toll } from '@classes/toll';
import { AutocompleteObjectValidator } from '@shared/validators/autocomplete-object-validator';
import { TollService } from 'app/core/services/toll.service';
import { UiService } from 'app/core/services/ui.service';
import * as _moment from 'moment';
const moment = _moment;
// import { environment } from '@environments/environment';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { MessageBox } from '@components/message-box/message-box.component';
import { TranslateService } from '@ngx-translate/core';
import { Role } from '@enums/role.enum';
import { AccountService } from 'app/core/services/account.service';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Component({
  selector: 'app-toll',
  templateUrl: './toll.component.html',
  styleUrls: ['./toll.component.scss'],
  styles: [`
  >>> app-toll {
    height: 100%;
    display: flex;
  }
`]
})
export class TollComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  tollForm: FormGroup;

  Role = Role;

  editMode = false;

  constructor(
    private formBuilder: FormBuilder,
    public tollService: TollService,
    public uiService: UiService,
    private autocompleteObjectValidator: AutocompleteObjectValidator,
    public dialog: MatDialog,
    public translateService: TranslateService,
    public accountService: AccountService,
    public envConfigurationService: EnvConfigurationService,
    @Optional() public dialogRef: MatDialogRef<TollComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: Toll
  ) { }

  ngOnInit() {
    this.initFormBuilder(this.data);
  }

  private initFormBuilder(value?: Toll) {
    var editMode = value ? (value?.id == null || (value?.billed)) : false;
    const fb = this.formBuilder;
    this.tollForm = fb.group({
      id: fb.control(value?.id),
      isError: fb.control(value?.isError),
      site: fb.control({ value: value?.site, disabled: editMode }, [Validators.required, this.autocompleteObjectValidator.autocompleteObjectValidator()]),
      company: fb.control({ value: value?.company, disabled: editMode }, [Validators.required, this.autocompleteObjectValidator.autocompleteObjectValidator()]),
      date: fb.control({ value: value?.date, disabled: editMode }, [Validators.required]),
      type: fb.control({ value: value?.isTruck != null ? (value?.isTruck ? '1' : '0') : null, disabled: editMode }, [Validators.required]),
      quantity: fb.control({ value: value?.quantity, disabled: editMode }, [Validators.required]),
      isExceptionalConvoy: fb.control({ value: value?.isExceptionalConvoy, disabled: editMode }, []),
      plate: fb.control({ value: value?.plate, disabled: editMode }, [Validators.maxLength(50)]),
      material: fb.control({ value: value?.material, disabled: editMode }, [Validators.required, this.autocompleteObjectValidator.autocompleteObjectValidator()]),
    });
    this.initUserData();
  }

  private initUserData() {
    if (this.accountService.currentUser.value?.company) {
      this.tollForm.get("company")?.setValue(this.accountService.currentUser.value?.company);
      this.tollForm.get("company")?.disable();
    }
  }

  onSubmit() {
    var checkBeforeSubmit = () => {
      if (this.data?.id && this.data?.isError && this.environment.application == 'supervision') {
        const messageBoxParameter = new MessageBoxParameter();

        messageBoxParameter.message = this.translateService.instant('label.remove-error-status');
        messageBoxParameter.dialog = this.dialog;
        messageBoxParameter.title = 'Attention';
        messageBoxParameter.buttons = ['yes', 'no'];
        messageBoxParameter.width = "400px";

        MessageBox.show(messageBoxParameter).subscribe(mbResult => {
          if (mbResult && mbResult.value) {
            this.tollForm.controls.isError.setValue(false);
            this.submit();
          }
          else {
            this.submit();
          }
        })
      } else {
        this.submit();
      }
    }

    if (this.tollForm.get("quantity")?.value > 2000) {
      const messageBoxParameter = new MessageBoxParameter();

      messageBoxParameter.message = this.translateService.instant('toll.quantity-exeed');
      messageBoxParameter.dialog = this.dialog;
      messageBoxParameter.title = 'Attention';
      messageBoxParameter.buttons = ['yes', 'no'];
      messageBoxParameter.width = "400px";

      MessageBox.show(messageBoxParameter).subscribe(mbResult => {
        if (mbResult && mbResult.value) {
          checkBeforeSubmit();
        }
        else {
          return false;
        }
      })
    }
    else {
      checkBeforeSubmit();
    }
  }

  patch() {
    this.uiService.addRouteLoading();
    this.tollService.createOrUpdateToll({
      id: this.tollForm.get("id")?.value,
      quantity: this.tollForm.get("quantity")?.value,
      materialId: this.tollForm.get("material")?.value.id,
      plate: this.tollForm.get("plate")?.value,
    }).subscribe(data => {
      this.initFormBuilder();
      this.uiService.removeRouteLoading();
      this.uiService.displayMessageToast('toll.success-edit');
      if (this.dialogRef) {
        this.dialogRef.close(true);
      }
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  private submit() {
    this.uiService.addRouteLoading();
    const toll = new Toll(
      this.tollForm.value
    );
    toll.isTruck = this.tollForm.value.type == "1";
    toll.company = this.tollForm.get("company")?.value;
    toll.companyId = this.tollForm.get("company")?.value.id;

    this.tollService.createOrUpdateToll(toll).subscribe(data => {
      this.initFormBuilder();
      this.uiService.removeRouteLoading();
      this.uiService.displayMessageToast('toll.success-edit');
      if (this.dialogRef) {
        this.dialogRef.close(true);
      }
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onDelete() {
    if (this.data && this.data.id) {

      const messageBoxParameter = new MessageBoxParameter();

      messageBoxParameter.message = this.translateService.instant('toll.confirm-delete');
      messageBoxParameter.dialog = this.dialog;
      messageBoxParameter.title = 'Confirmation';
      messageBoxParameter.buttons = ['yes', 'no'];
      messageBoxParameter.width = "400px";

      MessageBox.show(messageBoxParameter).subscribe(mbResult => {
        if (mbResult && mbResult.value) {
          this.uiService.addRouteLoading();
          this.tollService.deleteToll(this.data?.id || "").subscribe(data => {
            this.uiService.displayMessageToast('toll.success-delete');
            this.uiService.removeRouteLoading();
            if (this.dialogRef) {
              this.dialogRef.close(true);
            }
          }, error => {
            console.error(error);
            this.uiService.removeRouteLoading();
          });
        }
      });
    }
  }

  onEditQuantity() {
    const messageBoxParameter = new MessageBoxParameter();

    messageBoxParameter.message = this.translateService.instant('toll.confirm-edit');
    messageBoxParameter.dialog = this.dialog;
    messageBoxParameter.title = 'Confirmation';
    messageBoxParameter.buttons = ['yes', 'no'];
    messageBoxParameter.width = "600px";

    MessageBox.show(messageBoxParameter).subscribe(mbResult => {
      if (mbResult && mbResult.value) {
        this.tollForm.controls.quantity.enable();
        this.tollForm.controls.material.enable();
        this.tollForm.controls.plate.enable();
        this.editMode = true;
      }
    });
  }

  isRequiredField(field: string) {
    const form_field = <AbstractControl>this.tollForm.get(field);
    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return (validator && validator.required);
  }
}
